import React from 'react';
import { Hero } from '../components/Hero';
import { Problem } from '../components/Problem';
import { Solution } from '../components/Solution';
import { Expert } from '../components/Expert';
import { Benefits } from '../components/Benefits';
import { Included } from '../components/Included';
import { Bonuses } from '../components/Bonuses';
import { Transformation } from '../components/Transformation';
import { Testimonials } from '../components/Testimonials';
import { Offer } from '../components/Offer';
import { Guarantee } from '../components/Guarantee';
import { FAQ } from '../components/FAQ';
import { FinalCTA } from '../components/FinalCTA';
import { StickyCTA } from '../components/StickyCTA';
import { Footer } from '../components/Footer';
export function Landing() {
  return <div className="w-full min-h-screen bg-[#F5F0E8]" data-id="element-521">
      <Hero data-id="element-522" />
      <Problem data-id="element-523" />
      <Expert data-id="element-524" />
      <Solution data-id="element-525" />
      <Benefits data-id="element-526" />
      <Included data-id="element-527" />
      <Bonuses data-id="element-528" />
      <Transformation data-id="element-529" />
      <Testimonials data-id="element-530" />
      <Offer data-id="element-531" />
      <Guarantee data-id="element-532" />
      <FAQ data-id="element-533" />
      <FinalCTA data-id="element-534" />
      <Footer data-id="element-535" />
      <StickyCTA data-id="element-536" />
    </div>;
}